export { default } from './CirculatingSupply';



// WEBPACK FOOTER //
// ./src/components/CirculatingSupply/index.js